<div class="text-muted small" i18n="@@collection.config.tab.rules.cron.info">
  An automation executed regularly according to the timer settings.
</div>

<div [formGroup]="configForm" class="config-form mt-3">

  <label class="main" i18n="@@collection.config.tab.rules.cron.timer.every">Repeat every</label>
  <div class="d-flex align-items-center flex-nowrap">
    <input class="form-control me-2 interval-input" type="number"
           min="1" [max]="unitControl.value | maxIntervalByUnit" id="interval" formControlName="interval"
           integer minValue="1" [maxValue]="unitControl.value | maxIntervalByUnit"/>
    <select-item class="type-input" [items]="unitsItems"
                 [selectedId]="unitControl.value"
                 (selected)="onUnitSelect($event)">
    </select-item>
  </div>

  <ng-container *ngIf="unitControl.value | showDaysOfWeek">
    <label class="main" i18n="@@collection.config.tab.rules.cron.timer.repeat">Repeat on</label>
    <div class="d-flex align-items-center flex-wrap">
      <custom-checkbox *ngFor="let dayOfWeek of dayOfWeeks; let last = last"
                       [class.me-3]="!last"
                       [checkboxTitle]="dayOfWeek.title"
                       [checkboxId]="dayOfWeek.id"
                       [title]="dayOfWeek.tooltip"
                       [checked]="daysOfWeekControl.value | isDayOfWeekSelected:dayOfWeek.bit"
                       (checkedChange)="onDayOfWeekChange(dayOfWeek, $event)">
      </custom-checkbox>
    </div>
  </ng-container>

  <ng-container *ngIf="unitControl.value | showOccurrence">
    <label class="main" i18n="@@collection.config.tab.rules.cron.timer.run">Run on</label>
    <div class="d-flex align-items-center flex-nowrap">
      <input class="form-control hour-input me-2" type="number"
             min="1" max="31" id="occurrence" formControlName="occurrence" integer minValue="1" maxValue="31"/>
      <span i18n="@@collection.config.tab.rules.cron.timer.dayInMonth">day in month</span>
      <span class="text-secondary ms-1">
        <i class="fal fa-question-circle" i18n-tooltip="@@collection.config.tab.rules.cron.timer.monthly"
           tooltip="If a month has lower count of days, the automation is executed on the last day of month (i.e. enter 31 to always execute at the end of month)."></i>
      </span>
    </div>
  </ng-container>

  <label class="main" i18n="@@collection.config.tab.rules.cron.timer.start">Starts</label>
  <div>
    <date-time-input class="medium-input d-inline-block"
                     id="startsOnDate"
                     [format]="dateFormat"
                     [placeholder]="dateFormat"
                     [value]="startsOnControl.value"
                     (valueChange)="startsOnControl.setValue($event)">
    </date-time-input>
    <div *ngIf="configForm?.errors?.startsOnRequired" class="small mt-1 text-danger"
         i18n="@@collection.config.tab.rules.cron.timer.start.required">Please enter start date.
    </div>
  </div>

  <label class="main" i18n="@@collection.config.tab.rules.cron.timer.execute">Execute at</label>
  <div class="d-flex align-items-center flex-nowrap">
    <select-item class="me-2 medium-input" [items]="hoursItems"
                 [selectedId]="hourControl.value || '0'"
                 [removable]="false"
                 (selected)="hourControl.setValue($event)">
    </select-item>
    <span class="text-warning">
      <i class="fal fa-exclamation-triangle" i18n-tooltip="@@collection.config.tab.rules.cron.timer.delay"
         tooltip="The execution can be delayed up to several minutes depending on the server load."></i>
    </span>
  </div>

  <label class="align-self-start main" i18n="@@collection.config.tab.rules.cron.timer.ends">Ends</label>
  <div class="ends-on-form">

    <input type="radio" name="never" id="never" value="never"
           (change)="onNeverChecked($event.target.checked)"
           [checked]="!(endsOnControl.value | isDateValid) && !((executionsControl.value | isNotNullOrUndefined) && executionsControl.value >= 0)">
    <label for="never" i18n="@@collection.config.tab.rules.cron.timer.never">Never</label>
    <div>&nbsp;</div>

    <input type="radio" name="date" id="date" value="date"
           (change)="onEndsOnChecked($event.target.checked)"
           [checked]="endsOnControl.value | isDateValid">
    <label for="date" i18n="@@collection.config.tab.rules.cron.timer.on">On</label>
    <div>
      <date-time-input class="medium-input d-inline-block"
                       id="endsOnDate"
                       [placeholder]="dateFormat"
                       [format]="dateFormat"
                       [value]="endsOnControl.value"
                       (valueChange)="onEndDateChange($event)">
      </date-time-input>
      <div *ngIf="configForm?.errors?.endsOnInvalid" class="small mt-1 text-danger"
           i18n="@@collection.config.tab.rules.cron.timer.ends.invalid">The start date must be before the end date.
      </div>
    </div>

    <input type="radio" name="num" id="num" value="num"
           (change)="onExecutionsChecked($event.target.checked)"
           [checked]="(executionsControl.value | isNotNullOrUndefined) && executionsControl.value >= 0">
    <label for="num" i18n="@@collection.config.tab.rules.cron.timer.after">After</label>
    <div class="d-flex align-items-center">
      <input class="form-control me-2 interval-input" type="number"
             min="1" max="1000" id="executions"
             integer minValue="1" maxValue="1000" formControlName="executionsLeft"/>
      <span i18n="@@collection.config.tab.rules.cron.timer.executions">executions</span>
    </div>

  </div>

  <label class="align-self-start py-2 main" i18n="@@collection.config.tab.rules.cron.timer.view">View</label>
  <div class="view-input">
    <select-item [items]="viewsByCollection$ | async | viewsSelectItems:(collections$ | async):true"
                 class="w-100"
                 buttonClasses="w-100"
                 emptyValue="Select view"
                 i18n-emptyValue="@@projects.tab.template.metadata.defaultView.empty"
                 [removable]="true"
                 [selectedId]="viewControl.value"
                 [fitParent]="true"
                 (selected)="onSelectView($event)"
                 (remove)="onRemoveView()">
    </select-item>
    <div class="text-muted small mt-1" i18n="@@collection.config.tab.rules.cron.timer.records">Read records from this
      view and pass them to the automation. No records are passed when empty.
    </div>
  </div>

  <div class="pt-4">&nbsp;</div>
  <div class="pt-4 text-muted small" *ngIf="rule | ruleRunInfo as ruleRunInfo">
    <i class="far fa-clock pe-4"></i>
    <span class="pe-2" i18n="@@rule.run.info.last">Last run:</span>
    <span *ngIf="ruleRunInfo.lastRun" class="pe-4 fw-bold">{{ruleRunInfo.lastRun | date:'medium'}}</span>
    <span *ngIf="!ruleRunInfo.lastRun" class="pe-4 fst-italic" i18n="@@never">Never</span>
    <span class="pe-2" i18n="@@rule.run.info.next">Next run:</span>
    <span *ngIf="ruleRunInfo.nextRun" class="fw-bold">{{ruleRunInfo.nextRun | date:'medium'}}</span>
    <span *ngIf="!ruleRunInfo.nextRun" class="fst-italic" i18n="@@never">Never</span>
  </div>

</div>


